import type { DIVIDER_DATA, DIVIDER_PARAMS, DIVIDER_PARAMS_DEVICE } from './types'

import { DEFAULT_MARGIN, DEFAULT_PADDING, DEFAULT_WIDTH } from '../const'

const DEFAULT_DIVIDER_PARAMS_DEVICE = (): DIVIDER_PARAMS_DEVICE => ({
  hidden: false,
  borderStyle: 'solid',
  borderColor: '#000000',
  textAlign: 'left',
  width: DEFAULT_WIDTH(),
  borderWidth: { value: 1, unit: 'px' },
  color: '#000000',
  minHeight: { value: 1, unit: 'px' },
  margin: DEFAULT_MARGIN(),
  padding: DEFAULT_PADDING(),
  lineSpacing: { value: 37, unit: 'px' },
  rotation: { value: 0, unit: 'deg' },
})

export const DEFAULT_DIVIDER_PARAMS = (): DIVIDER_PARAMS => ({
  icon: 'right',
  style: null,
  pc: DEFAULT_DIVIDER_PARAMS_DEVICE(),
  tablet: DEFAULT_DIVIDER_PARAMS_DEVICE(),
  mobile: DEFAULT_DIVIDER_PARAMS_DEVICE(),
})

export const DEFAULT_DIVIDER_DATA = (): DIVIDER_DATA => ({
  id: null,
  classes: null,
  styles: null,
  type: 'divider',
  itemType: 'none',
  itemTag: 'span',
  itemIcon: null,
  data: {
    value: null,
  },
})